<template>
  <div class="m-4">
    <!--  If Quick search has been used and we have results -->
    <div v-if="['Phone', 'Email'].includes(quickSearchType) && customersLoaded">
      <h1 class="text-2xl font-bold leading-7 text-cool-gray-900 sm:leading-9">
        Customers
      </h1>
      <div class="m-2">
        <CustomersGrid height="800" />
      </div>
    </div>

    <div v-else-if="ordersLoaded">
      <h1 class="text-2xl font-bold leading-7 text-cool-gray-900 sm:leading-9">
        Orders
      </h1>
      <div class="m-2">
        <OrdersGrid height="800" />
      </div>
    </div>
  </div>
</template>
<script>
import CustomersGrid from "@/components/agGrid/CustomersGrid.vue";
import OrdersGrid from "@/components/agGrid/OrdersGrid.vue";

export default {
  name: "SearchResults",
  data() {
    return {
      slideoverVisibleEdit: false,
      slideoverVisibleSearch: false,
      searchType: null
    };
  },
  props: {},
  created() {},
  components: {
    CustomersGrid,
    OrdersGrid
  },
  computed: {
    quickSearchType() {
      return this.$store.getters.quickSearchType;
    },
    customers() {
      return this.$store.getters["customers/getCustomers"];
    },
    customersLoaded() {
      return this.$store.getters["customers/isCustomersLoaded"];
    },
    customersSearching() {
      return this.$store.getters["customers/isCustomersSearching"];
    },
    orders() {
      return this.$store.getters["orders/getOrders"];
    },
    ordersLoaded() {
      return this.$store.getters["orders/isOrdersLoaded"];
    },
    ordersSearching() {
      return this.$store.getters["orders/isOrdersSearching"];
    }
  },
  beforeMount() {},
  mounted() {},
  methods: {
    toggleSlideover() {
      this.slideoverVisibleSearch = !this.slideoverVisibleSearch;
    }
  },
  filters: {}
};
</script>
